import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("speedex_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Resolve a stored file url (adds auth token for protected files)
export function withAuthUrl(url) {
  if (!url) return url;
  if (url.startsWith("/api/files/")) {
    const token = localStorage.getItem("speedex_token");
    const full = `${BACKEND_URL}${url}`;
    return token ? `${full}?auth=${token}` : full;
  }
  return url;
}

export function fileUrl(url) {
  if (!url) return url;
  if (url.startsWith("/api/files/")) return `${BACKEND_URL}${url}`;
  return url;
}
